import { Loc } from 'main.core';

export const SectionMetaData = {
	appearance: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_APPEARANCE_MSGVER_1'),
		icon: 'fa-solid fa-brush',
	},
	notification: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_NOTIFICATION'),
		icon: 'fa-solid fa-bell',
	},
	hotkey: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_HOTKEY'),
		icon: 'fa-solid fa-keyboard',
	},
	message: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_MESSAGE'),
		icon: 'fa-solid fa-message',
	},
	recent: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_RECENT_MSGVER_1'),
		icon: 'fa-solid fa-list-ul',
	},
	desktop: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_DESKTOP'),
		icon: 'fa-solid fa-desktop',
	},
	help: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_HELP'),
		icon: 'fa-solid fa-question',
	},
	feedback: {
		name: Loc.getMessage('IM_CONTENT_SETTINGS_SECTION_LIST_FEEDBACK'),
		icon: 'fa-solid fa-comment',
	},
};
